import "./i18n";
import { BANKS_LIST as BASE_BANKS_LIST, BANKS_CREATE as BASE_BANKS_CREATE, BANKS_EDIT as BASE_BANKS_EDIT, BANKS_VIEW as BASE_BANKS_VIEW, } from "./config/routes";
import { UserRole } from "@root/api.types";
export const BANKS_LIST = {
    ...BASE_BANKS_LIST,
};
export const BANKS_CREATE = {
    ...BASE_BANKS_CREATE,
    roles: [UserRole.ADMIN],
};
export const BANKS_EDIT = {
    ...BASE_BANKS_EDIT,
    roles: [UserRole.ADMIN],
};
export const BANKS_VIEW = {
    ...BASE_BANKS_VIEW,
};
